module.exports = __webpack_public_path__ + "img/bg_history_museum.10c3ff17.jpg";